<mat-card class="w-100">
  <mat-card-content>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <mat-card-title class="mb-0">Notifications List</mat-card-title>
      <button mat-raised-button color="primary" (click)="addNotifications()" [disabled]="!hasSelection()">
        <span>Add Notification</span>
      </button>
    </div>
    <div class="filter-section">
      <div class="row">
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Select State</mat-label>
            <mat-select [formControl]="selectedState" (selectionChange)="onStateChange()">
              <mat-option value="">All States</mat-option>
              <mat-option *ngFor="let state of states" [value]="state.state">
                {{ state.state }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Select City</mat-label>
            <mat-select [formControl]="selectedCity" [disabled]="!selectedState.value || isCityLoading"
              (selectionChange)="onCityChange()">
              <mat-option value="">All Cities</mat-option>
              <mat-option *ngFor="let city of cities" [value]="city.city">
                {{ city.city }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" placeholder="Choose start date"
              [formControl]="startDateControl">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" placeholder="Choose end date" [formControl]="endDateControl">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>Start Scan Count</mat-label>
            <input matInput type="number" placeholder="Enter start scan count" [formControl]="startNumberControl" />
          </mat-form-field>
        </div>
        <div class="col-md-2 col-sm-6 mb-2">
          <mat-form-field class="w-100">
            <mat-label>End Scan Count</mat-label>
            <input matInput type="number" placeholder="Enter end scan count" [formControl]="endNumberControl" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="d-flex gap-2 align-items-center justify-content-between mb-2">
      <div class="d-flex gap-2 align-items-center">
        <button mat-raised-button color="accent" (click)="selectAllRows()">
          Select All
        </button>
        <button mat-raised-button color="warn" (click)="unselectAllRows()" *ngIf="hasSelection()">
          Unselect
        </button>
        <span class="selected-box" *ngIf="selection.selected.length > 0">
          {{ selection.selected.length }} Selected
        </span>
      </div>
      <div class="d-flex gap-2 align-items-center justify-content-end">
        <button mat-raised-button color="primary" (click)="applyDateFilter()" [disabled]="!hasActiveFilters()">
          Apply Filters
        </button>
        <button mat-raised-button color="warn" (click)="clearFilters()" *ngIf="hasActiveFilters()">
          Clear Filters
        </button>
      </div>
    </div>
    <div class="spinner" *ngIf="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div [hidden]="spinner" class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="text-nowrap w-100" matSort>
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleRow(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Username Column -->
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.username }}</p>
          </td>
        </ng-container>

        <!-- Company Name Column -->
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CompanyName</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.companyName }}</p>
          </td>
        </ng-container>

        <!-- Phone Number Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.phone }}</p>
          </td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.state }}</p>
          </td>
        </ng-container>

        <!-- City Column -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.city }}</p>
          </td>
        </ng-container>

        <!-- Scan Count Column -->
        <ng-container matColumnDef="scanCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Scan Count</th>
          <td mat-cell *matCellDef="let element">
            <p class="mb-0 fw-medium">{{ element.scanCount }}</p>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center" colspan="6">
            <p class="mt-24">
              No data matching the filter
            </p>
          </td>
        </tr>
      </table>
    </div>
    <mat-paginator #paginator [length]="totalRecords" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 25, 100]"
      [pageIndex]="pageIndex" showFirstLastButtons aria-label="Select page of users"></mat-paginator>
  </mat-card-content>
</mat-card>